/**
 * Mobile viewport detection composable
 * Tracks window width and mobile breakpoint status
 */

import { ref, onMounted, onUnmounted, type Ref } from 'vue'

/** Return type of useIsMobile composable */
export interface UseIsMobileReturn {
  isMobile: Ref<boolean>
  width: Ref<number>
  screenWidth: Ref<number>
}

/**
 * Detect mobile viewport and track window resize
 * @param breakpoint - Width threshold for mobile detection (default: 768px)
 * @returns Reactive mobile detection state
 */
export function useIsMobile(breakpoint = 768): UseIsMobileReturn {
  const isMobile = ref<boolean>(false)
  const width = ref<number>(0)
  const screenWidth = ref<number>(0)

  const checkIfMobile = (): void => {
    if (typeof window === 'undefined') return
    
    width.value = window.innerWidth
    isMobile.value = window.innerWidth < breakpoint
    screenWidth.value = window.innerWidth
  }

  onMounted(() => {
    checkIfMobile()
    window.addEventListener('resize', checkIfMobile)
  })

  onUnmounted(() => {
    window.removeEventListener('resize', checkIfMobile)
  })

  return {
    isMobile,
    width,
    screenWidth,
  }
}